/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Label, Row, Col, Button, Badge,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';
import { get, post } from '../../helpers/api_helper';

import BaseGrid from '../Common/BaseGrid';

function FuseTechOrder(props) {
  const {
    initialValues,
    workorder,
    onSuccess,
    t,
  } = props;

  const [selector, setSelector] = useState(false);
  const [manifest, setManifest] = useState(null);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const ValidationSchema = Yup.object().shape({
    reference: Yup
      .string()
      .required(props.t(t('Reference is required'))),
    instructions: Yup
      .string().nullable(),
    items: Yup.array().of(Yup.object().shape({
      item_id: Yup.number().nullable(),
      item_qty: Yup.number().required().min(1),
    })),
  });

  const submit = async (values) => {
    try {
      const data = {
        ...values,
        items: values.items.map((x) => ({
          item_id: x.item_id,
          item_qty: x.item_qty,
          id: x.item_id,
          exact: x.exact,
        })),
      };

      const result = await post(`/api/fuse/workorder/${workorder.id}/order`, data);

      onSuccess(result);
    } catch (error) {
      toastr.error(error.message, t('Error submitting tech order'));
    }
  };

  const buildManifest = async () => {
    try {
      const mani = await get(`/api/fuse/workorder/manifest/${workorder.id}`);

      const order = {
        ...initialValues,
        items: mani.map((x) => ({
          item_id: x.item_id,
          item_qty: x.qty,
          item: x.item,
          exact: x.exact,
        })),
      };

      setManifest(order);
    } catch (error) {
      toastr.error(error.message, t('Error getting manifest'));
    }
  };

  useEffect(() => {
    buildManifest();
  }, []);

  return (
    <Formik
      enableReinitialize
      initialValues={manifest !== null ? manifest : initialValues}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        submit(values);
      }}
    >
      {({
        // eslint-disable-next-line no-unused-vars
        touched, errors, values, setFieldValue,
      }) => (
        <Form className="mt-3 fuse-tech-order-form" id="TechOrderExportForm" autoComplete="off">
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label
                  for="reference"
                >
                  {props.t('Reference')}
                </Label>
                <Field className="form-control" id="reference" name="reference" />
                <ErrorMessage
                  name="reference"
                  component="div"
                  className="mt-2 text-danger"
                />
              </div>
            </Col>
          </Row>
          <div className="mb-3">
            <Label
              for="instructions"
            >
              {props.t('Delivery Instructions')}
            </Label>
            <Field className="form-control" id="instructions" name="instructions" />
            <ErrorMessage
              name="instructions"
              component="div"
              className="mt-2 text-danger"
            />
          </div>
          <h6 className="mt3">{t('Item Manifest')}</h6>

          <FieldArray name="items">
            {(arrayHelpers) => (
              <>
                {!selector && (
                  <Button color="soft-primary" size="sm" onClick={() => { setSelector(true); }}>
                    <span className="mdi mdi-plus-thick" />
                    {' '}
                    {t('Component')}
                  </Button>
                )}
                {selector && (
                <BaseGrid
                  url={`/api/fuse/workorder/${workorder.id}/matched`}
                  hasSearch
                  config={
                    {
                      columns: {
                        thumb: {
                          label: '',
                          image: {
                            src: (item) => (`/api/items/thumbnail/${item.id}`),
                            class: 'rounded',
                            style: { maxHeight: '5rem', maxWidth: '5rem' },
                          },
                          translate: false,
                        },
                        manufacturer: { label: props.t('Mnfctr'), sort: true },
                        part_number: { label: props.t('Part Number'), sort: true },
                        qty: { label: props.t('Qty'), sort: true },
                        matches: {
                          label: props.t('Matches'),
                          format: (f, x) => (
                            workorder.family.components.filter((y) => (
                              y.indexed_items.find((w) => w.id === x.id) !== undefined
                            )).map((y) => y.description)
                          ),
                          badges: {
                            class: 'bg-primary bg-soft text-dark p-1',
                          },
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              icon: 'mdi mdi-check',
                              class: 'btn btn-sm btn-soft-primary',
                              tooltip: props.t('Select'),
                              click: (itm) => {
                                const idx = values.items.find((x) => x.item_id === itm.id);
                                if (idx === undefined) {
                                  arrayHelpers.push({
                                    item_id: itm.id,
                                    item_qty: 1,
                                    item: itm,
                                  });
                                }

                                setSelector(false);
                              },
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'matches',
                        direction: 'desc',
                        perPage: 5,
                      },
                    }
                  }
                />
                )}

                <div className="hstack gap-2 mt-3">
                  <span className="fs-6">{t('Totals')}</span>
                  {workorder.family.components.filter((x) => ['any', 'component'].includes(x.scope)).map((x) => (
                    <Badge color="warning" className="badge-soft-warning fuse-tech-order-total fs-6 fw-semibold">
                      {x.description}
                      {': '}
                      <strong>
                        {values.items.filter((y) => x.indexed_items
                          .map((ii) => ii.id)
                          .includes(y.item.id))
                          .reduce((a, c) => a + c.item_qty, 0)}
                      </strong>
                    </Badge>
                  ))}
                </div>

                {values.items.length > 0 && (
                <table className="table table-bordered mt-3 fuse-workorder-table">
                  <thead>
                    <tr>
                      <th>{' '}</th>
                      <th>{t('ID')}</th>
                      <th>{t('Part Number')}</th>
                      <th>{t('Qty')}</th>
                      <th>{t('Remove')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {values.items.length !== undefined && values.items.map((row, ri) => (
                      <React.Fragment key={row.item.id}>
                        <tr>
                          <td className="align-middle">
                            <img className="rounded" style={{ maxWidth: '3rem', maxHeight: '3rem' }} src={`/api/items/thumbnail/${row.item_id}`} alt={row.item.part_number} />
                          </td>
                          <td className="align-middle">
                            <a href={`/item/${row.item_id}`}>
                              {row.item_id}
                            </a>
                          </td>
                          <td className="align-middle">
                            {row.item.part_number}
                            <div className="hstack gap-1 mt-1">
                              {workorder.family.components
                                .filter((x) => x.indexed_items.find((w) => w.id === row.item.id) && ['any', 'component'].includes(x.scope))
                                .map((x) => x.description).map((x) => (
                                  <Badge color="primary" className="bg-soft text-dark">
                                    <span className="mdi mdi-check-bold" />
                                    {' '}
                                    {x}
                                  </Badge>
                                ))}

                              {row.exact && (
                                <Badge color="success">
                                  <span className="mdi mdi-checkmark-bold" />
                                  {' '}
                                  {t('Exact Match')}
                                </Badge>
                              )}
                            </div>
                          </td>
                          <td className="align-middle">
                            <Field
                              className="form-control"
                              name={`items[${ri}].item_qty`}
                              type="number"
                              min="0"
                              max={row.item.qty}
                              step="1"
                            />
                          </td>
                          <td className="align-middle">
                            <Button color="soft-danger" size="sm" title={t('Remove from order')} onClick={() => { arrayHelpers.remove(ri); }}>
                              <span className="mdi mdi-close-thick" />
                            </Button>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
                )}
              </>
            )}
          </FieldArray>
        </Form>
      )}
    </Formik>
  );
}

FuseTechOrder.defaultProps = {
  t: (x) => (x),
  initialValues: {
    reference: '',
    instructions: '',
    items: [],
  },
  components: [],
};

FuseTechOrder.propTypes = {
  t: PropTypes.any,
  initialValues: PropTypes.object,
  components: PropTypes.array,
  workorder: PropTypes.object.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(FuseTechOrder));
